module.exports = __webpack_public_path__ + "static/media/stalkyard_clean_grid.23ae509f.jpg";